import { render, staticRenderFns } from "./ChangeNameThanks.vue?vue&type=template&id=2cf4e533&"
import script from "./ChangeNameThanks.vue?vue&type=script&lang=js&"
export * from "./ChangeNameThanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports